module.exports = __webpack_public_path__ + "static/media/0006.7e31d3fd.jpg";